import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/guide/page.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Guide.tsx");
